module.exports = __webpack_public_path__ + "static/media/BackArrow.c8ed97fe.svg";